import { take, fork, put, call, SagaReturnType } from "redux-saga/effects";

import { AuthActions, LOGIN } from "../../actions";

import authUserApi from "../../../api/apiServices/auth/controllers/user/user.api";

function* authorizeByCredentialsFlow() {
  while (true) {
    const { payload }: ReturnType<typeof AuthActions.login> = yield take(LOGIN);
    const { login, password } = payload;
    const { success, reject }: SagaReturnType<typeof authUserApi.login> = yield call(authUserApi.login, { login, password });
    if (success) {
      yield put(AuthActions.loginSuccess(success.payload));
    }

    if (reject) {
      yield put(AuthActions.loginError(reject.payload.errors!));
    }
  }
}

export function* loginFlow() {
  yield fork(authorizeByCredentialsFlow);
}
